import type { IToastService } from './ToastService.js';

/// Copy-to-clipboard per kravspec §15.16. Knap-feedback (1.5s check-ikon)
/// + "kopier alle"-aggregator der samler [data-copy-value] inde i nærmeste
/// .panel som flerlinje-tekst.

export interface IClipboardService {
  copyText(btn: HTMLElement, text: string): Promise<void>;
  copyAll(btn: HTMLElement): Promise<void>;
}

export class ClipboardService implements IClipboardService {
  private static readonly CHECK_FEEDBACK_MS = 1500;

  constructor(private readonly toasts: IToastService) { }

  async copyText(btn: HTMLElement, text: string): Promise<void> {
    await this.writeSafely(text);
    this.flashCheck(btn);
  }

  async copyAll(btn: HTMLElement): Promise<void> {
    const panel = btn.closest('.panel');
    if (!panel) return;

    const values = Array.from(panel.querySelectorAll<HTMLElement>('[data-copy-value]'))
      .map(el => el.getAttribute('data-copy-value') ?? '')
      .filter(v => v.length > 0);

    if (values.length === 0) return;
    await this.writeSafely(values.join('\n'));
    this.toasts.show('Alle records kopieret');
  }

  private async writeSafely(text: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // Browser-permission denied eller HTTP-context. Vi swallow'er fordi
      // copy er en convenience — fallback kunne være select+execCommand,
      // men det er deprecated, så vi accepterer at få browsere kan have
      // strict policies.
    }
  }

  private flashCheck(btn: HTMLElement): void {
    const original = btn.innerHTML;
    btn.classList.add('copied');
    btn.innerHTML = '<i class="ph ph-check"></i>';
    setTimeout(() => {
      btn.classList.remove('copied');
      btn.innerHTML = original;
    }, ClipboardService.CHECK_FEEDBACK_MS);
  }
}
